import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import { ReplyModal as ActionModal } from '../modals/reply';
const portTranslator = (node) => {
    if (node.payload.next_node_id) {
        return [
            {
                id: uuid(),
                type: 'out',
                label: 'arrow',
                connection: node.payload.next_node_id,
            },
        ];
    }
    return [];
};
export class ReplyNode extends NodeTypeComponent() {
    constructor() {
        super(...arguments);
        this.triggerEdit = () => {
            const { onEdit, node } = this.props;
            onEdit(node, node.nodeType);
        };
    }
    render() {
        const { node: { payload: { auto_reply_template_id }, }, } = this.props;
        return (_jsx(FlowNode, { color: ReplyNode.color, icon: ReplyNode.icon, label: ReplyNode.label, text: _jsxs("span", { children: ["Template ", _jsx("strong", { children: auto_reply_template_id })] }), onEdit: this.triggerEdit }));
    }
}
ReplyNode.icon = 'reply';
ReplyNode.label = 'Auto-reply';
ReplyNode.color = flowNodeColor.blue;
ReplyNode.translatePayload = formatPortsHelper(portTranslator);
ReplyNode.helpText = 'Send an automatic reply based on a custom template.';
ReplyNode.ActionModal = ActionModal;
ReplyNode.actionTrigger = { type: FlowNodeTypes.AUTOREPLY };
ReplyNode.updateConnection = (node, _port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    payload.next_node_id = newConnection;
    return Object.assign(Object.assign({}, node), { payload });
};
